export default __webpack_public_path__ + "static/media/logo2.64ff12f1.png";